function modal(){

    "use strict";

    $('.modal').on('shown.bs.modal', function (e) {
        $('.product-slider__view').slick("setPosition", 0);
    });
}

module.exports = modal;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/07_modal.js